import { AppButton } from '@components/AppButton/AppButton'
import { useMSW } from '@hooks/useMSW'
import { X } from 'lucide-react'

export const MSWControl: React.FC = () => {
  const { isActive, scenario, stop } = useMSW()

  if (!isActive) {
    return null
  }

  const buttonText = scenario ? `Stop MSW (${scenario})` : 'Stop MSW'
  const buttonTitle = scenario
    ? `MSW is active (scenario: ${scenario}). Click to stop.`
    : 'MSW is active. Click to stop.'

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AppButton
        variant="destructive"
        size="sm"
        onClick={() => {
          void stop()
        }}
        className="shadow-lg"
        title={buttonTitle}
      >
        <X className="mr-2 h-4 w-4" />
        {buttonText}
      </AppButton>
    </div>
  )
}
